<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <componentheader :title="title" />
        <div class="row">
          <div class="col-xl-3 col-md-4">
            <settingsidebar />
          </div>
          <div class="col-xl-9 col-md-8">
            <div class="card">
              <div class="card-header">
                <h5 class="card-title">Notifications</h5>
                <p>
                  Which email notifications would you like to receive when
                  something changes?
                </p>
              </div>
              <div class="card-body">
                <!-- Form -->
                <Form @submit.prevent="updateSettings">
                  <!-- Toggle Switch -->
                  <label
                    v-for="(option, index) in options"
                    :key="index"
                    class="row form-group toggle-switch"
                    :for="option.name"
                  >
                    <span class="col-8 col-sm-9 toggle-switch-content ms-0">
                      <span class="d-block text-dark">{{ option.name }}</span>
                      <span class="d-block text-muted">{{
                        option.description
                      }}</span>
                    </span>
                    <span class="col-4 col-sm-3">
                      <input
                        type="checkbox"
                        :value="option.value"
                        v-model="form.notifications"
                        class="toggle-switch-input"
                        :id="option.name"
                      />
                      <span class="toggle-switch-label ms-auto">
                        <span class="toggle-switch-indicator"></span>
                      </span>
                    </span>
                  </label>
                  <!-- /Toggle Switch -->

                  <div class="text-end">
                    <button
                      :disabled="isLoading"
                      type="submit"
                      class="btn btn-primary add-tax-save-btn"
                    >
                      <span
                        v-if="isLoading"
                        class="spinner-border spinner-border-sm me-1"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span v-if="!isLoading">Save Changes</span>
                      <span v-if="isLoading">Saving...</span>
                    </button>
                  </div>
                </Form>
                <!-- /Form -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
  <!-- /Main Wrapper -->
</template>
<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore();
const isLoading = ref(false);
const title = "Settings";

const form = ref({
  notifications: [],
});

// const options = [
//   {
//     name: "Invoice viewed",
//     description: "When your customer views the invoice sent via dashboard",
//     value: "invoice-viewed",
//   },
//   {
//     name: "Invoice paid",
//     description: "When your customer pays the invoice.",
//     value: "invoice-paid",
//   },
//   {
//     name: "Invoice reoccurring",
//     description: "When your customer set the invoice to reoccurring.",
//     value: "invoice-recurring",
//   },
//   {
//     name: "Invoice overdue",
//     description: "When the invoice is overdue.",
//     value: "invoice-overdue",
//   },
//   {
//     name: "Estimate viewed",
//     description: "When your customer views the estimate sent via dashboard.",
//     value: "estimate-viewed",
//   },
//   {
//     name: "Estimate accepted / declined",
//     description: "When your customer accepts or declines the estimate.",
//     value: "estimate-accepted-or-declined",
//   },
//   {
//     name: "Estimate reoccurring",
//     description: "When your customer sets the estimate to reoccurring.",
//     value: "estimate-recurring",
//   },
//   {
//     name: "Estimate expired",
//     description: "When the estimate expires.",
//     value: "estimate-expired",
//   },
// ];

const settings = computed(() => {
  return store.getters["settings/settings"];
});

const getSettings = () => {
  store.dispatch("settings/getSettings").then(() => {
    form.value = {
      notifications:
        settings.value.notifications == null
          ? []
          : settings.value.notifications,
    };
  });
};

const updateSettings = () => {
  isLoading.value = true;
  store
    .dispatch("settings/updateNotificationSettings", form.value)
    .then(() => {
      isLoading.value = false;
    })
    .catch(() => {
      isLoading.value = false;
    });
};

onMounted(() => {
  getSettings();
});
</script>
